(function instructionsEnhancer(global) {
  'use strict';

  const CONTENT_SELECTOR = '.article-content.halo-text-format';
  const COPY_PROPERTIES = ['textContent', 'innerText', 'innerHTML'];

  function normalizedText(node) {
    if (!node || typeof node.textContent !== 'string') return '';
    return node.textContent.replace(/\u00a0/g, ' ').trim();
  }

  function guardCopyMutation(node, propertyName) {
    if (COPY_PROPERTIES.includes(propertyName) && normalizedText(node)) {
      throw new Error(`Instructions enhancer blocked a ${propertyName} assignment on article copy.`);
    }
    return node;
  }

  function wrapNode(node, tagName, className) {
    if (!node || !node.parentNode || !node.ownerDocument) return null;
    const wrapper = node.ownerDocument.createElement(tagName);
    if (className) wrapper.classList.add(className);
    node.parentNode.insertBefore(wrapper, node);
    wrapper.appendChild(node);
    return wrapper;
  }

  function moveNode(node, newParent) {
    if (!node || !newParent) return null;
    newParent.appendChild(node);
    return node;
  }

  function markNode(node, className, attrs) {
    if (!node) return null;
    if (className) node.classList.add(className);
    Object.entries(attrs || {}).forEach(([name, value]) => {
      node.setAttribute(name, value);
    });
    return node;
  }

  function isEmptyParagraph(node) {
    if (!node || node.tagName !== 'P' || normalizedText(node)) return false;
    return Array.from(node.children).every((child) => child.tagName === 'BR');
  }

  function firstMeaningfulChild(content) {
    return Array.from(content.childNodes).find((node) => {
      if (node.nodeType === 8) return false;
      if (node.nodeType === 3) return Boolean(normalizedText(node));
      return node.nodeType === 1;
    }) || null;
  }

  function enhanceInstructions(content) {
    if (!content) return null;

    Array.from(content.querySelectorAll('p')).forEach((paragraph) => {
      if (isEmptyParagraph(paragraph)) paragraph.remove();
    });

    const leadingNode = firstMeaningfulChild(content);
    const isLeadingRule = leadingNode
      && typeof leadingNode.matches === 'function'
      && leadingNode.matches('hr')
      && !normalizedText(leadingNode);
    if (isLeadingRule) {
      leadingNode.remove();
    }

    return content;
  }

  function initInstructions(scope) {
    if (!scope || typeof scope.querySelector !== 'function') return null;
    return enhanceInstructions(scope.querySelector(CONTENT_SELECTOR));
  }

  const api = Object.freeze({
    wrapNode,
    moveNode,
    markNode,
    guardCopyMutation,
    enhanceInstructions,
    initInstructions
  });

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = api;
  }

  if (global) {
    global.DundonInstructions = api;
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initInstructions(document), { once: true });
    } else {
      initInstructions(document);
    }
  }
})(typeof window !== 'undefined' ? window : globalThis);
